var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            size: "medium",
            "header-cell-style": { background: "#f5f7fa", padding: "3px 0" },
            border: true,
            data: _vm.dataList,
          },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "", type: "index", label: "序号", width: "50" },
          }),
          _vm._v(" "),
          _vm._l(_vm._columns, function (column, index) {
            return _c("el-table-column", {
              key: index,
              attrs: { label: column.__config__.label },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var $index = ref.$index
                      return [
                        _c("render", {
                          attrs: {
                            info: _vm.dataList[$index],
                            conf: column,
                            option: _vm.option,
                          },
                          on: {
                            input: function (value) {
                              return _vm.setValue(
                                value,
                                undefined,
                                column,
                                $index
                              )
                            },
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "right", "min-width": "90", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          disabled: _vm.readonly,
                          type: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.delRow(scope.$index, scope.row)
                          },
                        },
                      },
                      [_vm._v("\n                    删除\n                ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { size: "small", icon: "el-icon-plus" },
          on: { click: _vm.addRow },
        },
        [_vm._v("添加数据")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }